import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const Container = styled(Box)`
  font-size: 10px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 70vh;
`;

export const StyledParagraph = styled(Typography)`
  font-weight: bold;
  font-size: 26px;
`;

export const StyledSpan = styled(Typography)`
  font-size: 14px;
`;
